import { render, staticRenderFns } from "./approvalProcess.vue?vue&type=template&id=6e1f68f6"
import script from "./approvalProcess.vue?vue&type=script&lang=js"
export * from "./approvalProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports